<template>
    <div class="complaint--layout">
        <div class="bc-container bc-container-header">
            <button class="btn btn-plain btn-plain-wicon button-close" type="button"
                    @click="back">
                <md-icon>arrow_back_ios</md-icon>
                Vissza a listához
            </button>
            <div v-if="countdown" class="countdown-timer">
                Szerkesztési zár: <strong>{{ countdown }}</strong>
            </div>
        </div>
        <div v-if="loading" class="complaint--con admin">
            Adatok betöltése...
        </div>
        <div v-else-if="isLocked" class="">
            <h2>A szerkesztés nem lehetséges</h2>
            <p>{{ lockMessage }}</p>
        </div>
        <div v-else class="complaint--con admin">
            <div>
                <div class="complaint--actions">
                    <div class="complaint--badge">
                        Státusz: {{ $t('complaints.statuses.' + form.status) }}
                    </div>

                    <hr style="margin: 5px 0px!important;">

                    <div class="complaint--actions-sub">
                        <button :disabled="!permissions.canUpdate || !enabledSendToSap"
                                @click="triggerSendToSap" class="done--button">
                            Kész, elküldöm a SAP-ba!
                        </button>

                        <button
                            v-if="form.type === 'quality'"
                            :disabled="!permissions.canUpdate || !enabledClose"
                            @click="triggerClose" class="accept--button"
                        >
                            Lezárom
                        </button>
                    </div>

                    <hr style="margin: 5px 0px!important;">

                    <div v-if="(permissions.canApprove || permissions.canDecline) && form.status !== 'done' && form.status !== 'closed'"
                         class="complaint--actions-tsub">
                        <button v-if="permissions.canApprove" :disabled="form.status === 'approved'"
                                @click="triggerApprove" class="accept--button">
                            Jóváhagyom
                        </button>

                        <button v-if="permissions.canDecline" :disabled="form.status === 'rejected'" @click="triggerDeny"
                                class="deny--button">
                            Elutasítom
                        </button>

                        <button
                            :disabled="!permissions.canUpdate || !enabledIncomplete"
                            @click="triggerIncomplete" class="incomplete--button">
                            Hiányosnak jelölöm!
                        </button>
                    </div>
                </div>

                <div class="mb-4">
                    <label for="user_id">Felelős</label>
                    <custom-select
                        id="user_id"
                        :selectedItem="selectedUser"
                        :disabled="disabled"
                        :large="true"
                        :options="users"
                        @changed="changeUser">
                    </custom-select>
                </div>

                <complaint-damage-form
                    v-if="form.type === 'damage'"
                    @submit="submitForm"
                    :disabled="disabled"
                    :edit="true"
                    :admin="true"
                    :loading="loading"
                    :form="form"
                />
                <complaint-quality-form
                    v-else
                    @submit="submitForm"
                    :disabled="disabled"
                    :edit="true"
                    :admin="true"
                    :loading="loading"
                    :form="form"
                />
            </div>

            <div>
                <complaint-files
                    :files="{warranty_file: form.warranty_file, delivery_note_files: form.delivery_note_files, photo_of_dmg_files: form.photo_of_dmg_files}"/>
                <complaint-products :complaint="$route.params.complaintId" :disabled="disabled && form.status !== 'approved'" @updated="fetch"/>
                <complaint-comments :complaint="$route.params.complaintId" @updated="fetch"/>
            </div>
        </div>

        <notification></notification>

        <modal-confirmation
            :open="openConfirmationModal"
            :data="confirmationModalData"
            @accepted="confirmAction"
            @close="openConfirmationModal = false">
        </modal-confirmation>

        <modal-incomplete
            :open="openIncompleteModal"
            :data="incompleteModalData"
            @accepted="sendIncomplete"
            @close="openIncompleteModal = false">
        </modal-incomplete>
    </div>
</template>

<script>
import config from '../plugins/config.js'
import axios from 'axios';
import Vue from 'vue'
import {MdIcon} from 'vue-material/dist/components'
import Notification from '../components/Notification.vue'
import ComplaintDamageForm from '../components/ComplaintDamageForm.vue'
import ComplaintFiles from '../components/ComplaintFiles.vue'
import ComplaintComments from '../components/ComplaintComments.vue'
import ComplaintProducts from '../components/ComplaintProducts.vue'
import ModalConfirmation from '../components/modals/ModalConfirmation.vue'
import ModalIncomplete from '../components/modals/ModalIncomplete.vue'
import ComplaintQualityForm from "@/components/ComplaintQualityForm.vue";
import CustomSelect from "@/components/dropdowns/CustomSelect.vue";

Vue.use(MdIcon)

export default {
    name: 'ComplainEdit',

    components: {
        CustomSelect,
        ComplaintQualityForm,
        Notification,
        ComplaintDamageForm,
        ComplaintFiles,
        ComplaintComments,
        ComplaintProducts,
        ModalConfirmation,
        ModalIncomplete
    },

    data() {
        return {
            users: [],
            loading: false,
            editDisabled: false,
            openConfirmationModal: false,
            openIncompleteModal: false,
            incompleteMessage: '',
            incompleteModalData: {},
            confirmationModalData: {},
            permissions: {},
            selectedUser: {},
            form: {
                status: null,
                status_text: null,
                id: null,
                user_id: null,
                name: '',
                phone: '',
                email: '',
                buyer_name: '',
                zip: '',
                county: '',
                city: '',
                street: '',
                house_number: '',
                products: [],
                installation_status: 'before',
                installation_date: '',
                delivery_note_number: null,
                delivery_note_files: null,
                delivery_note_files_preview: null,
                photo_of_dmg_files: null,
                photo_of_dmg_files_preview: null,
                warranty_file: null,
                warranty_file_preview: null,
            },
            isLocked: false,
            lockMessage: '',
            lockRefreshInterval: null,
            timerInterval: null,      // Ez az 1 másodperces számláló
            lockExpiresAt: null,      // Itt tároljuk a lejárati időt a backendtől
            countdown: null,          // A formázott "MM:SS" string
        }
    },

    methods: {
        async back() {

            this.$store.commit('resetProducts')
            this.$store.commit('resetValidation')

            if (window.history.length > 2) {
                return this.$router.back();
            }

            // Ha nincs, akkor a főoldalra irányítunk
            return this.$router.push({name: 'ComplaintQualityList'});
        },
        async changeUser(user) {
            this.selectedUser = user

            try {
                let formData = new FormData();
                formData.append('id', this.form.id);
                formData.append('user_id', this.selectedUser?.id ?? null);

                const response = await axios.post(`complaints/${this.form.id}/update-user`, formData, config.AXIOS_DEFAULTS);
                this.$store.commit('setNotification', [response.message])

                await this.fetch();

            } catch (response) {
                if (response.errors) {
                    this.$store.commit('setValidation', response.errors)
                }
            }
        },
        async submitForm() {
            try {
                this.loading = true;
                this.$store.commit('emptyValidation')

                let formData = new FormData();
                formData.append('id', this.form.id);
                formData.append('name', this.form.name);
                formData.append('phone', this.form.phone);
                formData.append('email', this.form.email);
                formData.append('buyer_name', this.form.buyer_name);
                formData.append('subject', this.form.subject);
                formData.append('county', this.form.county);
                formData.append('zip', this.form.zip);
                formData.append('city', this.form.city);
                formData.append('street', this.form.street);
                formData.append('house_number', this.form.house_number);
                formData.append('delivery_note_number', this.form.delivery_note_number);
                formData.append('message', this.form.message);
                formData.append('products', JSON.stringify(this.form.products));

                let url;
                if (this.form.type === 'damage') {
                    url = `complaints/${this.form.id}/update-damage`;
                } else {
                    url = `complaints/${this.form.id}/update-quality`;
                    formData.append('installation_status', this.form.installation_status);
                    formData.append('installation_date', this.form.installation_date);
                }

                if (this.form.delivery_note_files) {
                    this.form.delivery_note_files.forEach((file, index) => {
                        if (file instanceof File) {
                            formData.append(`delivery_note_files[${index}]`, file);
                        }
                    });
                }

                if (this.form.photo_of_dmg_files) {
                    this.form.photo_of_dmg_files.forEach((file, index) => {
                        if (file instanceof File) {
                            formData.append(`photo_of_dmg_files[${index}]`, file);
                        }
                    });
                }

                if (this.form.warranty_file) {
                    const file = Array.isArray(this.form.warranty_file) ? this.form.warranty_file[0] : this.form.warranty_file;
                    if (file instanceof File) {
                        formData.append(`warranty_file`, file);
                    }
                }

                const response = await axios.post(url, formData, config.AXIOS_DEFAULTS_WITH_FILE);
                this.$store.commit('setNotification', [response.message])

                await this.back()

            } catch (error) {
                this.loading = false;
                console.error("Hiba a mentéskor:", error);

                if (error.errors) {
                    this.$store.commit('setValidation', error.errors);
                    this.$store.commit('setNotification', ['Kérjük javítsa a hibákat az űrlapon!']);
                    return;
                }

                if (error.response) {
                    if (error.response.data && error.response.data.errors) {
                        this.$store.commit('setValidation', error.response.data.errors);
                        this.$store.commit('setNotification', ['Kérjük javítsa a hibákat az űrlapon!']);
                        return;
                    }

                    if (error.response.status === 413) {
                        this.$store.commit('setNotification', ['A feltöltött fájlok összmérete túl nagy! Próbáljon meg kevesebb vagy kisebb fájlt feltölteni.']);
                        return;
                    }

                    if (error.response.data && error.response.data.message) {
                        this.$store.commit('setNotification', [error.response.data.message]);
                        return;
                    }
                }

                this.$store.commit('setNotification', ['Váratlan hiba történt a mentés során.']);
            }
        },
        async fetch() {
            try {
                this.loading = true;
                const response = await axios.get(`/complaints/${this.$route.params.complaintId}/fetch`, config.AXIOS_DEFAULTS);

                const complaint = response.complaint;
                this.editDisabled = response.disabled;

                this.users = response.users;
                this.lockExpiresAt = response.lock_expires_at;

                this.selectedUser = this.users.find(user => user.id === complaint.user_id) ?? {};
                this.permissions = complaint.permissions;

                this.form = {
                    id: complaint.id,
                    type: complaint.type,
                    name: complaint.name,
                    user_id: complaint.user_id,
                    status: complaint.status,
                    status_text: complaint.status_text,
                    phone: complaint.phone,
                    email: complaint.email,
                    buyer_name: complaint.buyer_name,
                    product_name: complaint.product_name,
                    product_qty: complaint.product_qty,
                    zip: complaint.zip,
                    county: complaint.county,
                    city: complaint.city,
                    street: complaint.street,
                    products: complaint.products,
                    house_number: complaint.house_number,
                    installation_status: complaint.installation_status,
                    installation_date: complaint.installation_date,
                    delivery_note_number: complaint.delivery_note_number,
                    delivery_note_files: complaint.delivery_note_files || null,
                    photo_of_dmg_files: complaint.photo_of_dmg_files || null,
                    warranty_file: complaint.warranty_file || null,
                    message: complaint.message
                };

                this.isLocked = false;
                this.startLockRefresh();
                this.startCountdown();

                this.loading = false;

            } catch (error) {
                console.error("Error fetching complaint:", error.response.status);
                // HTTP 423 Locked
                if (error.response && error.response.status === 423) {
                    // A backend jelezte, hogy zárolva van
                    this.isLocked = true;
                    this.lockMessage = error.message;
                }
                if (error.response && error.response.status === 404) {
                    this.$store.commit('setNotification', ['Reklamáció nem található!'])
                    await this.back()
                }
            } finally {
                this.loading = false;
            }
        },

        // Actions

        askForApproval() {
            axios.post(`/complaints/${this.form.id}/ask-for-approval`, {}, config.AXIOS_DEFAULTS)
                .then(response => {
                    this.$store.commit('setNotification', [response.message])
                    this.fetch();
                })
                .catch(error => {
                    console.error("Error sending approval request:", error);
                    this.$store.commit('setNotification', [error.message])
                });
        },

        sendToSap() {
            axios.post(`/complaints/${this.form.id}/send-to-sap`, {}, config.AXIOS_DEFAULTS)
                .then(response => {
                    this.$store.commit('setNotification', [response.message])
                    this.fetch();
                })
                .catch(error => {
                    console.error("Error sending to SAP:", error);
                    this.$store.commit('setNotification', [error.message])
                });
        },

        close() {
            axios.post(`/complaints/${this.form.id}/close`, {}, config.AXIOS_DEFAULTS)
                .then(response => {
                    this.$store.commit('setNotification', [response.message])
                    this.fetch();
                })
                .catch(error => {
                    console.error("Error closing:", error);
                    this.$store.commit('setNotification', [error.message])
                });
        },

        approve() {
            axios.post(`/complaints/${this.form.id}/approve`, {}, config.AXIOS_DEFAULTS)
                .then(response => {
                    this.$store.commit('setNotification', [response.message])
                    this.fetch();
                })
                .catch(error => {
                    console.error("Error sending approval request:", error);
                    this.$store.commit('setNotification', [error.message])
                });
        },

        deny(message) {
            axios.post(`/complaints/${this.form.id}/deny`, {message: message}, config.AXIOS_DEFAULTS)
                .then(response => {
                    this.$store.commit('setNotification', [response.message])
                    this.fetch();
                })
                .catch(error => {
                    console.error("Error sending approval request:", error);
                    this.$store.commit('setNotification', [error.message])
                });
        },

        confirmAction() {
            if (this.confirmationModalData.action === 'askForApproval') {
                this.askForApproval();
            } else if (this.confirmationModalData.action === 'sendToSap') {
                this.sendToSap();
            } else if (this.confirmationModalData.action === 'close') {
                this.close()
            } else if (this.confirmationModalData.action === 'approve') {
                this.approve();
            }

            this.openConfirmationModal = false;
        },

        // Modal triggers ...
        triggerAskForApproval() {
            this.confirmationModalData = {
                acceptText: 'Igen, jóváhagyást kérek',
                cancelText: 'Mégsem',
                message: 'Biztosan jóváhagyást szeretne kérni a reklamációra?',
                action: 'askForApproval'
            };
            this.openConfirmationModal = true;
        },

        triggerApprove() {
            this.confirmationModalData = {
                acceptText: 'Igen, jóváhagyom',
                cancelText: 'Mégsem',
                message: 'Biztosan jóváhagyja a reklamációt?',
                action: 'approve'
            };
            this.openConfirmationModal = true;
        },

        triggerDeny() {
            this.incompleteModalData = {
                acceptText: 'Igen, elutasítom',
                cancelText: 'Mégsem',
                message: 'Fejtse ki, miért utasítja el a reklamációt',
                action: 'deny'
            };
            this.openIncompleteModal = true;
        },

        triggerSendToSap() {
            this.confirmationModalData = {
                acceptText: 'Igen, küldje be a SAP-ba',
                cancelText: 'Mégsem',
                message: 'Biztosan be szeretné küldeni a SAP-ba?',
                action: 'sendToSap'
            };
            this.openConfirmationModal = true;
        },

        triggerClose() {
            this.confirmationModalData = {
                acceptText: 'Igen, lezárom',
                cancelText: 'Mégsem',
                message: 'Biztosan le szeretné zárni? Lezárt reklamáció nem lesz a SAP-ba beküldve!',
                action: 'close'
            };
            this.openConfirmationModal = true;
        },

        triggerIncomplete() {
            this.incompleteModalData = {
                acceptText: 'Elküldés a vevőnek',
                cancelText: 'Mégsem',
                message: 'Fejtse ki, mi volt a hiányos a reklamációban.',
                action: 'incomplete'
            };
            this.openIncompleteModal = true;
        },

        sendIncomplete(data) {

            if (this.incompleteModalData.action === 'deny') {
                this.deny(data.message);
            } else {
                axios.post(`/complaints/${this.form.id}/send-incomplete`, {message: data.message}, config.AXIOS_DEFAULTS)
                    .then(response => {
                        this.$store.commit('setNotification', [response.message])
                        this.fetch();
                    })
                    .catch(error => {
                        console.error("Error sending to SAP:", error);
                        this.$store.commit('setNotification', [error.message])
                    });
            }
            this.openIncompleteModal = false;
        },

        unlockComplaint() {
            // Csak akkor küldjük a kérést, ha miénk a zár
            if (!this.isLocked && this.form.id) {
                // A `navigator.sendBeacon` megbízhatóbb oldal elhagyásakor, de az axios is működhet
                axios.post(`/complaints/${this.form.id}/unlock`, {}, config.AXIOS_DEFAULTS);
            }
        },
        handleBeforeUnload(event) {
            // Ez biztosítja, hogy a böngészőfül bezárásakor is megpróbáljuk feloldani
            this.unlockComplaint();
        },
        startLockRefresh() {
            clearInterval(this.lockRefreshInterval);

            // 10 percenként meghívjuk az edit endpointot,
            // ami frissíti a `locked_at` időbélyeget a backenden.
            this.lockRefreshInterval = setInterval(() => {
                axios.get(`/complaints/${this.$route.params.complaintId}/fetch`, config.AXIOS_DEFAULTS)
                    .catch(err => {
                        // Ha közben valaki más elvette a zárat, jelezzük a usernek
                        alert("A szerkesztési idő lejárt, valaki más átvette a panaszt.");
                        clearInterval(this.lockRefreshInterval);
                        return this.back()
                    });
            }, 10 * 60 * 1000); // 10 perc milliszekundumban
        },
        startCountdown() {
            clearInterval(this.timerInterval);

            this.timerInterval = setInterval(() => {
                const now = new Date();
                const expiration = new Date(this.lockExpiresAt);
                const diffSeconds = Math.round((expiration - now) / 1000);

                if (diffSeconds <= 0) {
                    clearInterval(this.timerInterval);
                    this.countdown = '00:00';
                    // Itt dönthetsz, mi történjen:
                    // 1. Csak egy üzenet
                    alert('A szerkesztési idő lejárt!');
                    // 2. Visszairányítás a listára
                    return this.back()
                }

                const minutes = Math.floor(diffSeconds / 60);
                const seconds = diffSeconds % 60;

                // Formázás, hogy mindig két számjegy legyen (pl. 05:09)
                this.countdown = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
            }, 1000); // Másodpercenként frissítjük
        },
    },

    async created() {
        await this.fetch();
        window.addEventListener('beforeunload', this.handleBeforeUnload);
    },
    beforeDestroy() {
        // Komponens elhagyásakor feloldjuk a zárat és töröljük az intervalt
        this.unlockComplaint();
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
        clearInterval(this.lockRefreshInterval);
        clearInterval(this.timerInterval);
    },

    computed: {
        enabledSendToSap() {
            if (this.form.status !== 'approved') {
                return false;
            }

            if (!this.form.products) {
                return false;
            }

            return this.form.products.length > 0
        },
        enabledClose() {
            return this.form.status === 'approved'
        },
        enabledIncomplete() {
            return this.form.status !== 'approved' &&
                this.form.status !== 'done' &&
                this.form.status !== 'incomplete' &&
                this.form.status !== 'closed'
        },
        disabled() {
            if (this.isLocked || this.editDisabled) {
                return true;
            }

            return this.form.status === 'approved' || this.form.status === 'done' || this.form.status === 'closed';
        }
    }
}
</script>

<style lang="scss">
@import '../assets/sass/toolkit.scss';
@import '../assets/sass/ui/button.scss';
@import '../assets/sass/layout/list-page.scss';
</style>